import React from 'react';
import { Model, Validation } from "@singularsystems/neo-core";
import { Neo, NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services";
import * as Roles from "../../../AccessControl/Models/Commands/Security/Roles";
import OrganisationSettingLookup from '../../../Common/Models/OrganisationSettingLookup';
import { AppService, Types } from '../../StaticData/StaticDataTypes';
import OrganisationSettingSearchCriteria from '../../../Common/Models/OrganisationSettingSearchCriteria';
import OrganisationSetting from '../../../Common/Models/OrganisationSetting';
import { AxiosPromise } from 'axios';

export default class OrganisationSettingPagedCatalogueEntry extends Catalogue.PagedCatalogueEntry<OrganisationSettingSearchCriteria, OrganisationSettingLookup, OrganisationSetting> {

    constructor(private apiClient = AppService.get(Types.ApiClients.GeneralApiClient)) {
        super("Organisation Settings", OrganisationSettingSearchCriteria, OrganisationSettingLookup, OrganisationSetting,
            {
                sortBy: "organisationName",
                fetchInitial: true,
                pageSize: 10,
                pageSizeOptions: [10, 20, 50],
            }
        );
    }

    public organisations = this.apiClient.getStaticOrganisationList().then((res) => {
        return res.data;
    });

    public get editRole() {
        return Roles.OrganisationConfigurationsRoles.Edit;
    }

    public getPagedDataEndpoint() {
        return this.apiClient.getOrganisationSettings;
    }

    public getSaveEndpoint() {
        return this.apiClient.saveOrganisationSetting;
    }

    public getModel(item: OrganisationSettingLookup): AxiosPromise<Model.PlainObject<OrganisationSettingLookup>> {
        return this.apiClient.getOrganisationSetting(item.organisationSettingId);
    }

    public renderCriteria(criteria: OrganisationSettingSearchCriteria, meta: Model.TransformMetaType<OrganisationSettingSearchCriteria>) {
        return (
            <Neo.GridLayout lg={3}>
                <Neo.FormGroup label="Organisation Name" bind={meta.organisationName} />
                <Neo.FormGroup label="Attribute" bind={meta.attribute} />
                <Neo.FormGroup label="Value" bind={meta.value} />
            </Neo.GridLayout>
        )
    }

    public renderRow(item: OrganisationSettingLookup, meta: Model.TransformMetaType<OrganisationSettingLookup>) {
        return (
            <NeoGrid.RowGroup>
                <NeoGrid.Row>
                    <NeoGrid.Column display={meta.organisationName} />
                    <NeoGrid.Column display={meta.attribute} />
                    <NeoGrid.Column display={meta.value} />
                    <Catalogue.ButtonColumn />
                </NeoGrid.Row>
            </NeoGrid.RowGroup>
        );
    }

    public renderFormControls(item: OrganisationSetting, meta: Model.TransformMetaType<OrganisationSetting>) {
        return <div>
            <Neo.Form
                validationDisplayMode={Validation.DisplayMode.AfterSubmit}>
                <Neo.GridLayout md={3}>
                    <Neo.FormGroup
                        bind={meta.organisationId}
                        select={{ items: this.organisations, displayMember: "organisationName", valueMember: "organisationId" }}>
                    </Neo.FormGroup>
                    <Neo.FormGroup
                        bind={meta.attribute}
                    >
                    </Neo.FormGroup>
                    <Neo.FormGroup
                        bind={meta.value}
                    >
                    </Neo.FormGroup>
                </Neo.GridLayout>
            </Neo.Form>
        </div>
    }
}